<template>
<div class="flex w-full vx-row no-gutter justify-center">
   <div class="vx-col sm:w-full md:w-full lg:w-3/5">
    <!-- <start-study v-show="!isStart" v-bind:studyInfo="studyInfo" @onStart="onStart"/> -->
    <mini-quiz v-if="isMiniQuiz" v-bind:miniQuiz="miniQuiz" v-bind:retry="retry" @onMiniQuizFinished="onMiniQuizFinished"></mini-quiz>

    <vx-card class="study-card" v-show="!isMiniQuiz">
      <vs-list>
        <vs-list-header title="원어민 발음에 집중하여 잘 들어 보세요." icon-pack="feather" icon="icon-info"></vs-list-header>
        <vs-list-item class="msg-grp-container">
          <vs-chip color="warning mr-0">{{ contentIndex + 1 }} / {{contentsLen}}</vs-chip>
        </vs-list-item>
      </vs-list>

      <!-- <div class="knowledge-base-jumbotron"> -->
        <div class="lg:p-32 md:p-24 sm:p-16 p-8 rounded-lg mb-base text-center">
          <h1 class="mb-1 text-primary sentence">원어민 발음에 집중하여 잘 들어 보세요.</h1>
          <p class="text-primary">Listen carefully by focusing on the pronunciation of the native speaker.</p>
        </div>
      <!-- </div> -->
      
      <div class="text-center" >
        <audio ref="audioPlayer" 
            controls 
            hidden
            v-on:ended="audioFinish" 
            controlsList="nodownload">Your browser does not support the <code>audio</code> element.
        </audio>
      </div>
    </vx-card>
    <top-button-bar @onReload="onReload" @onNext="onNext" @onFinish="onFinish" ></top-button-bar>    
  </div>  
  
</div>
</template>

<script>
import StudyMenuMixin from './StudyMenuMixin'
import { fetchData } from '@/api/module'
import TopButtonBar      from './TopButtonBar.vue'
import MiniQuiz          from './MiniQuiz.vue'
// import StartStudy          from './StartStudy.vue'

export default {
  mixins: [StudyMenuMixin],
  components: {
    TopButtonBar,
    MiniQuiz
  },
  
  data () {
    return {
      contentList: [],
      contentsLen: 0,
      contentIndex: 0,
      isMiniQuiz: false,
      miniQuiz: []
    }
  },
  watch: {
  },
  computed: {
    audioPlayer () {
      return this.$refs.audioPlayer
    },
    content () {
      return this.contentList[this.contentIndex]
    }
  },
  methods: {
    onReload () {
      this.audioPlayer.pause()
      this.contentIndex = 0
      this.isMiniQuiz = false
      this.startAlert()
    },
    onStart () {
      this.audioPlayer.src = this.content.audio
      this.audioPlayer.play()
    },
    audioFinish () {
      if (this.contentIndex < (this.contentsLen - 1)) {
        this.contentIndex++
        this.audioPlayer.src = this.content.audio
        this.audioPlayer.play()
      } else {
        this.isMiniQuiz = true
      }
    },
    onMiniQuizFinished (ret) {
      this.studyResult = ret
      this.onComplete()
      //this.onComplete()
      // const result = {
      //   studyContentSeq: this.sourceContent.studyContentSeq,
      //   result: ret
      // }
      // this.$emit('onComplete', result)
    },
    acceptAlert () {
      this.onStart()
    },
    startAlert () {
      this.startStudyDlg('원어민 발음에 집중하여 잘 들어 보세요.')
    },
    async loadQuiz (contentCode) {

      try { 
        const { data } = await fetchData(`study-content/quiz/${contentCode}`)
        this.miniQuiz = data.list
      } catch (error) {

        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    }
  },
  created () {

    this.loadQuiz(this.sourceContent.contentCode)

    const contentJson = JSON.parse(this.sourceContent.contentBody)
    for (let i = 0; i < contentJson.sentence.length; i++) {
      const content = {
        sentence: contentJson.sentence[i],
        audio: this.$buildAudioPath(this.sourceContent.contentCode, i + 1)
      } 
      this.contentList.push(content)
    }
    
    this.contentsLen = this.contentList.length
    this.startAlert()
  }
}

</script>

